/* eslint-disable no-undef */
/* eslint-disable no-new */
import { dimensionEndpoint } from './endpoints.js';
import logger from './util-logger';

export default {
    init: () => {
        const loader = document.querySelector('.mdl-spinner.mdl-loader');

        const settings = {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
        };

        function redirectToLogin() {
            localStorage.clear();
            window.location.href = '/';
        }

        function checkSession(json){
            const err = json.errors;
            if (err){
                logger.low(err);
                for ( const [key, value] of Object.entries(err)) {
                    logger.debug('key: ' + key);
                    logger.debug('value: ' + value);
                    key == 'E011' ?  redirectToLogin() : '';
                }
            }
        }

        function loadData(){
            fetch(dimensionEndpoint, settings )
                .then( (response) => { return response.json(); })
                .then( (json) => {
                    loader.classList.add('is-active');
                    const data = json.data;
                    logger.debug(json);
                    const dimensions = data.dimensions;
                    populateDropdowns(dimensions);
                    checkSession(json);
                    return data;
                }).then( () => {
                    // if ( !document.querySelector('.editCampaign') || !document.querySelector('.addPage') ) {
                    //     //styleDropDowns();
                    // }
                }).then( () => {
                    loader.classList.remove('is-active');
                }).catch((error) => {
                    logger.crit(error);
                });
        }

        function populateDropdowns(dimensions){
            dimensions.map( (d) => {
                const name = d.name;
                const types = d.type;
                document.querySelectorAll('form select').forEach((select) => {
                    const type = select.dataset.name;
                    if ( type == name ) {
                        const compareVals = (a, b) => {
                            return a[1].toString().localeCompare(b[1].toString(), 'en', { numeric: true });
                        };
                        const entries = Object.entries(d.reference_values).sort(compareVals);
                        entries.forEach( (val) => {
                            const option = document.createElement('option');
                            option.setAttribute('data-id', val[0]);
                            option.setAttribute('value', `${val[0]}`);
                            option.setAttribute('data-type', types);
                            option.setAttribute('data-val', val[1]);
                            option.innerText = val[1];
                            select.append(option);
                        });
                    }
                });
            });
        }

        if ( document.querySelector('.addPlacements') || document.querySelector('.addCreatives') || document.querySelector('.addAdgroups') || document.querySelector('.addEmails') || document.querySelector('.editCampaign') ){
            loadData();
        }
    }
};